import Types from './Types';

export const getAllSubjectAssistPhonesRequest = (body) => ({
    type: Types.GET_SUBJECT_ASSIST_PHONES_REQUEST,
    payload: body
});

export const getAllSubjectAssistPhonesSuccess = (data) => ({
    type: Types.GET_SUBJECT_ASSIST_PHONES_SUCCESS,
    payload: data
});

export const getAllSubjectAssistPhonesFail = () => ({
    type: Types.GET_SUBJECT_ASSIST_PHONES_FAIL
});

export const editSubjectAssistPhoneRequest = (formData, action) => ({
    type: Types.EDIT_SUBJECT_ASSIST_PHONE_REQUEST,
    payload: formData,
    action: action
});

export const editSubjectAssistPhoneSuccess = (data) => ({
    type: Types.EDIT_SUBJECT_ASSIST_PHONE_SUCCESS,
    payload: data
});

export const editSubjectAssistPhoneFail = () => ({
    type: Types.EDIT_SUBJECT_ASSIST_PHONE_FAIL
});

//LOADING
export const addSubjectAssistPhonesLoading = (isLoading) => ({
    type: Types.ADD_SUBJECT_ASSIST_PHONES_LOADING,
    payload: isLoading
});

// Create SubjectAssistPhone
export const createSubjectAssistPhoneRequest = (formData, action) => ({
    type: Types.CREATE_SUBJECT_ASSIST_PHONE_REQUEST,
    payload: formData,
    action: action
});

export const createSubjectAssistPhoneSuccess = ({ data }) => ({
    type: Types.CREATE_SUBJECT_ASSIST_PHONE_SUCCESS,
    payload: {
        data
    }
});

export const createSubjectAssistPhoneFail = () => ({
    type: Types.CREATE_SUBJECT_ASSIST_PHONE_FAIL
});

export const deleteSubjectAssistPhoneRequest = (id) => ({
    type: Types.DELETE_SUBJECT_ASSIST_PHONE_REQUEST,
    payload: id
});

export const deleteSubjectAssistPhoneSuccess = (id) => ({
    type: Types.DELETE_SUBJECT_ASSIST_PHONE_SUCCESS,
    payload: id
});

export const deleteSubjectAssistPhoneFail = () => ({
    type: Types.DELETE_SUBJECT_ASSIST_PHONE_FAIL
});

